import '../styles/LandingPage/Variables.css';

import useCursor       from '../LandingpageHooks/Usecursor';
import Navbar          from '../Navbar/Navbar';
import Hero            from '../LandingpageHooks/Hero';
import Ticker          from '../LandingpageHooks/Ticker';
import Phases          from '../LandingpageHooks/Phases';
import ResearchPillars from '../LandingpageHooks/Researchpillars';
import Outputs         from '../LandingpageHooks/Outputs';
import Advisory        from '../LandingpageHooks/Advisory';
import CtaBand         from '../LandingpageHooks/Ctaband';
import Footer          from '../LandingpageHooks/Footer';
import ValuationEngineSpotlight from '../ValuationEngine/ValuationEngineSpotlight';

export default function LandingPage() {
  const CursorElements = useCursor();

  return (
    <>
      {CursorElements}
      <Navbar />
      <Hero />
      <Ticker />
      <ValuationEngineSpotlight />
      <Phases />
      <ResearchPillars />
      <Outputs />
      <Advisory />
      <CtaBand />
      <Footer />
    </>
  );
}
